/**
 * Admin View exchange landing page.
 *
 * Owner Admin → Customer Detail → "View as Admin" opens this URL in a new
 * tab: /admin-view?token=av_<...>&ws=<workspace_id>
 *
 * We stash the session token in localStorage (via setSessionToken) and
 * redirect to the target workspace's dashboard. The `AdminViewBanner` in
 * AppLayout renders the red overlay while the session is active.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setSessionToken } from '../fetchInterceptor';
import { Loader2 } from 'lucide-react';

export default function AdminViewStart() {
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    const ws = params.get('ws');
    if (token) {
      setSessionToken(token);
      // Send the admin straight to the customer's dashboard. `?ws=` is
      // handled by WorkspaceContext to auto-select that workspace on load.
      const next = ws ? `/dashboard?ws=${encodeURIComponent(ws)}` : '/dashboard';
      window.location.replace(next);
    } else {
      window.location.replace('/');
    }
  }, [params]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-200"
      data-testid="admin-view-start-page"
    >
      <div className="flex items-center gap-3 text-sm">
        <Loader2 className="h-5 w-5 animate-spin text-red-400" />
        Starting Admin View session…
      </div>
    </div>
  );
}
